import { render, staticRenderFns } from "./NHSLookup.vue?vue&type=template&id=76cc88b4"
import script from "./NHSLookup.vue?vue&type=script&lang=js"
export * from "./NHSLookup.vue?vue&type=script&lang=js"
import style0 from "./NHSLookup.vue?vue&type=style&index=0&id=76cc88b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports